
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/returns?${queryString}`);
    return response.data;
  },
  async get(id) {
    const response = await https.get(`/returns/${id}`);
    return response.data;
  },
  async add(payload) {
    const response = await https.post(`/returns`, payload);
    return response.data;
  },
  async update(id, payload) {
    const response = await https.put(`/returns/${id}`, payload);
    return response.data;
  },
  async deleteById(id) {
    const response = await https.delete(`/returns/${id}`);
    return response.data;
  },
  async refresh(id) {
    const response = await https.post(`/returns/${id}/refresh`);
    return response.data;
  },
  async refreshAll() {
    const response = await https.post(`/returns/refresh-all`);
    return response.data;
  },
  async complete(id) {
    const response = await https.post(`/returns/${id}/complete`);
    return response.data;
  },
  async reopen(id) {
    const response = await https.post(`/returns/${id}/reopen`);
    return response.data;
  },
  async pin(id) {
    const response = await https.post(`/returns/${id}/pin`);
    return response.data;
  },
  async scan(code) {
    const response = await https.get(`/returns/scan/${encodeURIComponent(code)}`);
    return response.data;
  },
  async process(id, payload) {
    const response = await https.post(`/returns/${id}/process`, payload);
    return response.data;
  },
  async uploadPhoto(id, formData) {
    const response = await https.post(`/returns/${id}/photos`, formData);
    return response.data;
  },
  async deletePhoto(id, photoId) {
    const response = await https.delete(`/returns/${id}/photos/${photoId}`);
    return response.data;
  },
  async updateClaim(id, payload) {
    const response = await https.put(`/returns/${id}/claim`, payload);
    return response.data;
  },
  async updateRefundNeeded(id, payload) {
    const response = await https.put(`/returns/${id}/refund-needed`, payload);
    return response.data;
  },
  async resendZendeskNote(id) {
    const response = await https.post(`/returns/${id}/zendesk-note`);
    return response.data;
  },
  async sync(source) {
    const response = await https.post(`/returns/sync/${source}`);
    return response.data;
  },
  async syncStatus() {
    const response = await https.get(`/returns/sync-status`);
    return response.data;
  },
  async scanLogs(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/scan-logs?${queryString}`);
    return response.data;
  },
  async settings() {
    const response = await https.get(`/returns/settings`);
    return response.data;
  },
  async updateSetting(key, value) {
    const response = await https.put(`/returns/settings/${key}`, { value });
    return response.data;
  },
});
